export default __webpack_public_path__ + "static/media/news-3.7e0386d5.jpg";